// extracted by mini-css-extract-plugin
export default {"edit":"edit___f2eac993d37015ad","wrap":"wrap___bcf78fd75ca5294f","fullWidth":"fullWidth___c32c2567bc58305f"};